import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-blog-masonary',
  templateUrl: './blog-masonary.component.html',
  styleUrls: ['./blog-masonary.component.css']
})
export class BlogMasonaryComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
